import './index.css';

import Game from './game.js';

document.addEventListener('DOMContentLoaded', event => {
  const app = Game(document.getElementById('root'));
})
